module.exports = __webpack_public_path__ + "static/img/04_ava_scripted_conversation_cornelius_carstens.09adda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/ava/04_ava_scripted_conversation_cornelius_carstens.png
// module id = Mf8X
// module chunks = 1